import { cloneDeep } from "lodash";

const SET_SELECTED_DASHBOARD = "app/dashboard/SET_SELECTED_DASHBOARD";
const SET_DASHBOARD_EMBED_URL = "app/dashboard/SET_DASHBOARD_EMBED_URL";
const SET_AVAILABLE_DASHBOARDS = "app/dashboard/SET_AVAILABLE_DASHBOARDS";

const initialState = {
  selectedDashboardId: null,
  dashboardEmbedUrl: null,
  availableDashboards: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_DASHBOARD: {
      const clonedState = cloneDeep(state);

      const dashboardId = action.payload;

      if (clonedState.selectedDashboardId !== dashboardId) {
        clonedState.dashboardEmbedUrl = null;
      }

      clonedState.selectedDashboardId = dashboardId;

      return clonedState;
    }
    case SET_DASHBOARD_EMBED_URL: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        dashboardEmbedUrl: action.payload
      };
    }
    case SET_AVAILABLE_DASHBOARDS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        availableDashboards: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setSelectedDashboardId = (dashboardId) => ({
  type: SET_SELECTED_DASHBOARD,
  payload: dashboardId
});

export const setDashboardEmbedUrl = (embedUrl) => ({
  type: SET_DASHBOARD_EMBED_URL,
  payload: embedUrl
});

export const setAvailableDashboards = (dashboards) => ({
  type: SET_AVAILABLE_DASHBOARDS,
  payload: dashboards
});
